import React, { useEffect, useState } from 'react';
import { EMPTY_STRING } from '@assetron/common/constants/constant';
import { toasterSubject } from './ToasterService';
import ToasterPortal from './ToasterPortal';

interface ToasterState {
  open: boolean;
  type: 'success' | 'warning' | 'error';
  message: string;
  onClose?: () => void;
}

function ToasterContainer() {
  const [toaster, setToaster] = useState<ToasterState>({
    open: false,
    type: 'success',
    message: EMPTY_STRING,
    onClose: () => {},
  });

  useEffect(() => {
    const subscription = toasterSubject.subscribe((value: unknown) => {
      setToaster({
        open: true,
        type: value.type,
        message: value.message,
        onClose: value.onClose,
      });
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleClose = () => {
    toaster.onClose?.();
    setToaster({ ...toaster, open: false });
  };

  return (
    <ToasterPortal
      open={toaster.open}
      type={toaster.type}
      message={toaster.message}
      onClose={handleClose}
    />
  );
}

export default ToasterContainer;
